/* ============================================================
   Ogé Exclusive, aanvulling van de winkelwagen-upsells

   De vastgezette producten staan al in de HTML als dit bestand draait:
   die komen server-side mee uit snippets/oge-cart-upsells.liquid. Wat
   hier gebeurt is alleen het gat vullen. Zijn er minder vastgezette
   kaarten dan de winkelier wil tonen, of is er niets vastgezet, dan
   vraagt dit bestand de Recommendations API om de rest, met het laatst
   toegevoegde artikel als zaadje.

   Waarom het gesplitst is: de lade gaat open op het moment dat er iets
   in de mand is gelegd, en dat is precies het verkeerde moment om de
   inhoud te laten springen. Wat de winkelier zelf heeft gekozen staat
   er dus meteen; de aanvulling mag een halve seconde later komen.

   De lade wordt bij elke wijziging opnieuw gerenderd door de Section
   Rendering API, dus dit draait ook opnieuw. Vandaar de vlag op het
   element in plaats van een vlag in dit bestand.
   ============================================================ */
(function () {
  'use strict';

  var DONE = 'ogeUpsellsDone';

  function cardsIn(html) {
    var box = document.createElement('div');
    box.innerHTML = html;
    return Array.prototype.slice.call(box.querySelectorAll('.oge-upsells__item'));
  }

  function fill(root) {
    if (root.dataset[DONE] === '1') return;
    root.dataset[DONE] = '1';

    var limit = parseInt(root.dataset.ogeUpsellLimit, 10) || 4;
    var seed = root.dataset.ogeUpsellSeed;
    var have = root.querySelectorAll('.oge-upsells__item').length;
    if (!seed || have >= limit) return;

    var url =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/') +
      'recommendations/products?section_id=oge-cart-upsells&limit=8&product_id=' +
      encodeURIComponent(seed);

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var cards = cardsIn(html);
        if (!cards.length) return;

        // Alles wat al staat overslaan: de vastgezette rij kan hetzelfde
        // product bevatten als de aanbeveling, en twee keer dezelfde
        // kaart naast elkaar leest als een fout.
        var seen = {};
        Array.prototype.forEach.call(
          root.querySelectorAll('[data-oge-upsell-product]'),
          function (item) {
            seen[item.dataset.ogeUpsellProduct] = true;
          }
        );

        var list = root.querySelector('.oge-upsells__list');
        if (!list) {
          // Er stond nog niets: de kop hoort er dan ook nog niet te
          // staan, dus die komt nu pas mee.
          var heading = root.querySelector('.oge-upsells__title');
          if (!heading) {
            heading = document.createElement('p');
            heading.className = 'oge-upsells__title';
            heading.textContent = root.dataset.ogeUpsellHeading || '';
            if (heading.textContent) root.appendChild(heading);
          }
          list = document.createElement('ul');
          list.className = 'oge-upsells__list';
          list.setAttribute('role', 'list');
          root.appendChild(list);
        }

        var room = limit - root.querySelectorAll('.oge-upsells__item').length;
        cards.forEach(function (card) {
          if (room <= 0) return;
          var id = card.dataset.ogeUpsellProduct;
          if (seen[id]) return;
          seen[id] = true;
          room -= 1;
          list.appendChild(card);
        });

        wireTiles(root);
        root.classList.add('is-filled');
      })
      .catch(function () {
        // Geen aanbevelingen is geen fout: de vastgezette rij staat er,
        // of de rij blijft leeg. Beide zijn een prima eindtoestand.
      });
  }

  /* ------------------------------------------------------------
     De tegel is de knop.

     In de opmaak staat de foto als link naar het product, zodat er
     zonder JavaScript nog iets gebeurt. Hier wordt hij omgekat tot
     knop: de klik gaat naar de quick-add die eronder in de kaart staat,
     visueel verborgen maar wel een echt formulier naar /cart/add. Die
     kent het verschil tussen een product met één variant en een met
     keuzes, en hij ververst de lade na afloop.

     Het gebeurt op de link zelf en niet gedelegeerd op document, omdat
     de rol en het label ook gezet moeten worden: een link die in
     werkelijkheid iets aan de winkelwagen toevoegt en dat niet
     aankondigt, is voor wie hem niet ziet gewoon een leugen.
     ------------------------------------------------------------ */
  function wireTiles(root) {
    var label = root.dataset.ogeUpsellAddLabel || '';
    Array.prototype.forEach.call(
      root.querySelectorAll('[data-oge-upsell-tile]'),
      function (tile) {
        if (tile.dataset.ogeWired === '1') return;

        var item = tile.closest('.oge-upsells__item');
        var button = item && item.querySelector('.quick-add__button');
        if (!button) return;

        tile.dataset.ogeWired = '1';
        tile.setAttribute('role', 'button');
        var name = item.querySelector('.oge-upsells__name');
        if (label && name) {
          tile.setAttribute('aria-label', label.replace('@@', name.textContent.trim()));
        }

        tile.addEventListener('click', function (event) {
          event.preventDefault();
          button.click();
        });
      }
    );
  }

  function init(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-oge-upsells]').forEach(function (root) {
      wireTiles(root);
      fill(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // De lade wordt bij elke wijziging opnieuw ingevoegd, dus de verse
  // kopie draagt de vlag niet en moet opnieuw aangevuld worden.
  document.addEventListener('shopify:cart:lines-update', function () {
    window.setTimeout(init, 0);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
